/** 添付ファイルを開くリンク。クリックすると画面内のポップアップでプレビューする */
import { useState } from 'react';
import FilePreviewModal from './FilePreviewModal';
import type { StoredFile } from '@core/lib/types';

export default function AttachmentLink({ file, label }: { file: StoredFile; label?: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="txn-link" onClick={() => setOpen(true)} title={file.name}>
        {label ?? file.name}
      </button>
      {open && <FilePreviewModal file={file} onClose={() => setOpen(false)} />}
    </>
  );
}
